import BaseApi from '@/services/base.api.js';
import config from '@/config';

class UnitApi extends BaseApi {
  async createUnit(data) {
    let client = await this.getClient();
    return client({
      method: 'post',
      url: `${this.basicUrl}api/Unit`,
      data: data
    });
  }

  async getUnits() {
    let client = await this.getClient();
    return client({
      method: 'get',
      url: `${this.basicUrl}api/Unit/units-for-web`
    });
  }

  async getOneUnit(unitGuid) {
    let client = await this.getClient();
    return client({
      method: 'get',
      url: `${this.basicUrl}api/Unit/${unitGuid}`
    });
  }

  async setContacts(urlGuid, data) {
    let client = await this.getClient();
    return client({
      method: 'post',
      url: `${this.basicUrl}api/Unit/${urlGuid}/contacts`,
      data: data
    });
  }

  async updateUnit(urlGuid, unitUpdate) {
    let client = await this.getClient();
    return client({
      method: 'put',
      url: `${this.basicUrl}api/Unit/${urlGuid}`,
      data: unitUpdate
    });
  }

  async saveGroups(data) {
    let client = await this.getClient();
    return client({
      method: 'post',
      url: `${this.basicUrl}api/machinegroup/create`,
      data: data
    });
  }

  async deleteUnit(urlGuid) {
    let client = await this.getClient();
    return client({
      method: 'delete',
      url: `${this.basicUrl}api/unit/${urlGuid}`
    });
  }

  async uploadImage(data) {
    let client = await this.getClient();
    let formData = new FormData();

    let { imageData, imagePurpose, unitGuid } = data;
    formData.append('ImageData', imageData);
    formData.append('UnitGuid', unitGuid);
    formData.append('ImagePurpose', imagePurpose);

    return client({
      method: 'POST',
      url: `${this.basicFunctionUrl}api/image`,
      data: formData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    });
  }

  async getTimeZone(geoLocation) {
    let axios = require('axios');
    let client = axios.create();
    delete axios.defaults.headers.common['Authorization'];
    return client({
      method: 'get',
      url: `https://maps.googleapis.com/maps/api/timezone/json?location=${geoLocation}&timestamp=${Math.floor(Date.now() / 1000)}&key=${config.googleApiKey}`
    });
  }

  async shareUnit(data) {
    let { unitGuid } = data;
    let client = await this.getClient();
    return client({
      method: 'POST',
      url: `${this.basicUrl}api/unit/${unitGuid}/admin/share`,
      data: data
    });
  }

  async changePermission(data) {
    let { unitGuid } = data;
    let client = await this.getClient();
    return client({
      method: 'POST',
      url: `${this.basicUrl}api/unit/${unitGuid}/admin/changepermission`,
      data: data
    });
  }

  async removeUser(data) {
    let { unitGuid } = data;
    let client = await this.getClient();
    return client({
      method: 'DELETE',
      url: `${this.basicUrl}api/unit/${unitGuid}/removeuser`,
      data: data
    });
  }

  async leaveUnit(data) {
    let { unitGuid } = data;
    let client = await this.getClient();
    return client({
      method: 'POST',
      url: `${this.basicUrl}api/unit/${unitGuid}/leave`
    });
  }

  async moveMachine(data) {
    let { machineGuid, targetMachineGroupGuid } = data;
    let client = await this.getClient();
    return client({
      method: 'PUT',
      url: `${this.basicUrl}api/machine/${machineGuid}/move`,
      data: { targetMachineGroupGuid }
    });
  }

  async addCard(data) {
    let { groupGuid } = data;
    let client = await this.getClient();
    return client({
      method: 'POST',
      url: `${this.basicUrl}api/machinegroup/${groupGuid}/addmachines`,
      data: data
    });
  }

  async deleteCard(data) {
    let client = await this.getClient();
    return client({
      method: 'DELETE',
      url: `${this.basicUrl}api/machine/${data}`
    });
  }

  async updateCard(urlGuid, cardUpdate) {
    let client = await this.getClient();
    return client({
      method: 'put',
      url: `${this.basicUrl}api/machine/${urlGuid}/configuration`,
      data: cardUpdate
    });
  }

  async updateCardName(urlGuid, data) {
    let client = await this.getClient();
    return client({
      method: 'put',
      url: `${this.basicUrl}api/machine/${urlGuid}/name`,
      data: data
    });
  }

  async deleteGroup(data) {
    let client = await this.getClient();
    return client({
      method: 'DELETE',
      url: `${this.basicUrl}api/machinegroup/${data}`
    });
  }

  async renameGroup(data) {
    let { groupName, urlGuid } = data;
    let client = await this.getClient();
    return client({
      method: 'PUT',
      url: `${this.basicUrl}api/machinegroup/${urlGuid}`,
      data: { name: groupName }
    });
  }

  async renameCard(data) {
    let { cardName, urlGuid } = data;
    let client = await this.getClient();
    return client({
      method: 'PUT',
      url: `${this.basicUrl}api/machine/${urlGuid}/name`,
      data: { name: cardName }
    });
  }

  async copyProductionCounter(data) {
    const { machineGuid, wireposition, copyTarget } = data;
    let client = await this.getClient();
    return client({
      method: 'PUT',
      url: `${this.basicUrl}api/machine/${machineGuid}/wire/${wireposition}/copyProductionCounterTo/${copyTarget}`
    });
  }

  async getCurrentMachine(machineGuid) {
    let client = await this.getClient();
    return client({
      method: 'GET',
      url: `${this.basicUrl}api/machine/${machineGuid}`
    });
  }

  async getWiresForMachine(id) {
    let client = await this.getClient();
    return client({
      method: 'GET',
      url: `${this.basicUrl}api/machine/${id}/maintenance`
    });
  }

  async getWiresOptionForPosition(data) {
    let { machineId, wirePositionId } = data;
    let client = await this.getClient();
    return client({
      method: 'GET',
      url: `${this.basicUrl}api/machine/${machineId}/wire/${wirePositionId}/getavailablewires`
    });
  }

  async setWireOnPosition(data) {
    let { machineId, wirePositionId, wireId } = data;
    let client = await this.getClient();
    return client({
      method: 'PUT',
      url: `${this.basicUrl}api/machine/${machineId}/wire/${wirePositionId}/updatewire/${wireId}`
    });
  }

  async removeWireOnPosition(data) {
    let { machineId, wirePositionId } = data;
    let client = await this.getClient();
    return client({
      method: 'DELETE',
      url: `${this.basicUrl}api/machine/${machineId}/wirepos/${wirePositionId}`
    });
  }

  async updateTons(data) {
    let { machineId } = data;
    let client = await this.getClient();
    return client({
      method: 'PUT',
      url: `${this.basicUrl}api/machine/${machineId}/tons`,
      data: data
    });
  }

  async getMachineConfigurationData() {
    let client = await this.getClient();
    return client({
      method: 'GET',
      url: `${this.basicUrl}api/machine/configurationmenudata`
    });
  }

  async getMachineConfigurationDataForConfiguredMachine(machineGuid) {
    let client = await this.getClient();
    return client({
      method: 'GET',
      url: `${this.basicUrl}api/machine/${machineGuid}/configurationMenuDataForConfiguredMachine`
    });
  }

  async identifyMachine(data) {
    let { machineGuid } = data;
    let client = await this.getClient();
    return client({
      method: 'PUT',
      url: `${this.basicUrl}api/machine/${machineGuid}/configuration`,
      data: data
    });
  }

  async maintenance(data) {
    let { machineGuid } = data;
    let client = await this.getClient();
    return client({
      method: 'PUT',
      url: `${this.basicUrl}api/machine/${machineGuid}/maintenance`,
      data: data
    });
  }

  async getCopyConfiguration(machineGuid) {
    let client = await this.getClient();
    return client({
      method: 'GET',
      url: `${this.basicUrl}api/machine/${machineGuid}/copy`
    });
  }

  async copyConfiguration(data) {
    let { machineGuid } = data;
    let client = await this.getClient();
    return client({
      method: 'PUT',
      url: `${this.basicUrl}api/machine/${machineGuid}/copy`,
      data: data
    });
  }

  async easySetupData(data) {
    let client = await this.getClient();
    return client({
      method: 'GET',
      url: `${this.basicUrl}api/common/easysetupdata`,
      data: data
    });
  }

  async easySetupTestData(data) {
    let client = await this.getClient();
    return client({
      method: 'POST',
      url: `${this.basicUrl}api/common/debug/generateeasysetupdataforcurrentuser`,
      data: data
    });
  }

  async changeMachineState(data) {
    let client = await this.getClient();
    return client({
      method: 'PUT',
      url: `${this.basicUrl}api/machine/UpdateMachineState`,
      data: data
    });
  }
}

export default UnitApi;
